import React, { useEffect, useState } from "react";
const heroImages = [
  "/Hero-section/image-1.webp",
  "/Hero-section/image-2.webp",
  "/Hero-section/image-3.webp",
  "/Hero-section/image-4.webp",
  "/Hero-section/image-5.webp",
  "/Hero-section/image-6.webp"
];

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? heroImages.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-fade-section" id="home">
      {heroImages.map((img, index) => (
        <div
          key={index}
          className={`hero-fade-slide ${index === currentIndex ? "active" : ""}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}

      <div className="hero-overlay">
        <div className="hero-content">
          <h1>South India’s Trusted Goods Export & Import Partner</h1>
          <p>Seamless logistics solutions for businesses — on-time, cost-effective, and secure transportation across southern states.</p>
          <a href="#contact" className="btn-primary d-none">Get a Free Quote</a>
        </div>
      </div>

      <button className="nav-arrow left" onClick={prevSlide}>❮</button>
      <button className="nav-arrow right" onClick={nextSlide}>❯</button>
    </section>
  );
}

export default Home;
